module.exports = __webpack_public_path__ + "img/c7.bf3d91cb.jpg";